<template>
    <div>

        <config-main-title v-if="!setup">
            Usuários
        </config-main-title>

        <div v-if="!em_edicao">

            <div class="form-row mb-1" v-if="!setup">
                <div class="col col-12 col-md-3">
                    <az-input icon="fas fa-filter" 
                        type="select"
                        optionsMode="aql"
                        service="perfils.index"
                        :optionsParm="{ uso: true }"
                        v-model="filtroPerfil" 
                        @input="load ()">
                        <template v-slot:buttonposb>
                            <div class="input-group-append">
                                <button class="btn btn-outline-secondary" type="button" id="button-addon2" @click="editar_perfil_bloco()" title="Editar acessos.">
                                    <i class="fa-solid fa-lock-open"></i>
                                </button>
                            </div>
                        </template>
                    </az-input>
                </div>
                <div class="col col-12 col-md-6">
                    <az-input icon="fas fa-search" ref="pesquisa" v-model="search">
                        <template v-slot:buttonposb>
                            <importacao service="usuarios" @refresh="load()">
                                <template v-slot:instrucao>
                                    <p class="alert alert-info">
                                        O campo tipo deve ser importado com uma das opções abaixo:
                                        <ul>
                                            <li>ADM - Administrador (Acesso as configurações)</li>
                                            <li>CC - Call Center</li>
                                            <li>REC - Recepção</li>
                                            <li>MED - Médico</li>
                                            <li>FIN - Financeiro</li>
                                            <li>FAT - Faturamento</li>
                                        </ul>
                                    </p>
                                </template>
                            </importacao>

                            <div class="input-group-append">
                                <button class="btn btn-outline-primary" type="button" id="button-addon2" @click="incluir()">
                                    <i class="fa fa-plus" aria-hidden="true"></i>
                                </button>
                            </div>
                        </template>
                    </az-input>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <div class="btn-group mb-1" role="group" aria-label="Basic example">
                        <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'A'">
                            Ativos
                        </button>
                        <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'T'">
                            Todos
                        </button>
                    </div>
                </div>
            </div>

            <div class="mb-3 d-flex flex-column" v-else-if="( lista && lista.length ) || setup">
                <button type="button" class="btn btn-primary" @click="incluir ()">
                    <i class="fa fa-plus mr-2" aria-hidden="true"></i>
                    Incluir Usuário
                </button>
            </div>

        </div>

        <div v-if="!lista || !lista.length" class="mt-2">
            <az-empty-state 
                :msg="'Nenhum usuário identificado.'" 
                icon="fa fa-user" />
		</div>

        <div v-if="!em_edicao && lista && lista.length">

            <div class="text-right mb-1">
                <span class="badge badge-secondary" title="Quantidade">{{ lista.length }}</span>
            </div>

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item d-flex justify-content-between hover-bg" v-for="(dado, id) in lista" :key="id">
                    <span>
                        <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3">
                            {{ dado.search }}
                        </a>
                        <span v-if="dado.medico" class="mr-3">
                            <i class="fa-solid fa-user-doctor"></i>
                        </span>

                        <small class="text-muted mr-3">({{ dado.st_login }})</small>
                        <span v-if="dado.pessoa.cadastro">
                            <i class="far fa-envelope mr-1 text-warning" v-if="dado.pessoa.cadastro.st_email"></i>
                            {{ dado.pessoa.cadastro.st_email }}
                        </span>
                    </span>
                    <span>
                        <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                            <input type="checkbox" class="custom-control-input" 
                                :id="'ativo-' + id" 
                                v-model="dado.fl_ativo" 
                                @change="toggle(dado)">
                            <label class="custom-control-label" :for="'ativo-' + id"></label>
                        </div>
                        <div v-else class="d-flex">
                            <div v-if="dado.js_classes" :class="setup ? '' : 'mr-3'">
                                <a href="#" @click.prevent="search == '&quot;' + tag + '&quot;' ? search = '' : search = '&quot;' + tag + '&quot;'"
                                    v-for="(tag, itx) in dado.js_classes" :key="itx">
                                    <span class="badge badge-success ml-1">
                                        {{ tag }}
                                    </span>
                                </a>
                            </div>

                            <template v-if="!setup">
                                <a href="#" class="card-link ml-1" @click.prevent="abrir_anexos (dado)">
                                    <span class="badge badge-primary" v-if="dado.arquivos && dado.arquivos.length">
                                        {{ dado.arquivos.length }}
                                    </span>
                                    <i class="fa fa-paperclip fa-fw" aria-hidden="true"></i>
                                </a>
                                <a href="#" class="card-link" @click.prevent="alterarSenha(dado)">
                                    <i class="fas fa-key"></i>
                                </a>
                                <a href="#" class="card-link" @click.prevent="editarPermissao(dado)">
                                    <i class="fas fa-user-lock"></i>
                                </a>
                            </template>
                        </div>
                    </span>
                </li>
            </div>

            <br><br><br><br><br>

            <nav class="navbar fixed-bottom navbar-light bg-light pb-3" v-if="dados && dados.data">
                <div class="d-flex">
                    <template v-if="dados.last_page > 1">
                        <paginate
                            class="mb-0"
                            :page-count="dados.last_page"
                            :container-class="'pagination'"
                            :page-class="'page-item'"
                            :page-link-class="'page-link'"
                            :prev-class="'page-link'"
                            :next-class="'page-link'"
                            :prev-text="'<<'"
                            :next-text="'>>'"
                            :click-handler="paginar">
                        </paginate>
                    </template>

                    <div class="spinner-border ml-2" role="status" v-if="$store.state.loading">
                        <span class="sr-only">Loading...</span>
                    </div>
                </div>
                <div>
                    <span>
                        {{ lista.length }} / {{ dados.total }} 
                    </span>
                    
                    <!--
                    <button class="btn btn-outline-primary ml-2" @click="abrir_modal_vincular_tuss()" v-if="viewItemMode == 'T'">
                        <i class="fa fa-link mr-2" aria-hidden="true" v-if="!carregando"></i>
                        <div class="spinner-border spinner-border-sm mr-2" role="status" v-else>
                          <span class="sr-only">Loading...</span>
                        </div>
                        {{ ( tabela && tabela.st_aplicacao == 'MIX' ) ? 'Vincular / Código' : 'Vincular / TUSS' }} 
                    </button>
                    <button class="btn btn-primary ml-2" @click="abrir_modal_importar()">
                        <i class="fa fa-upload mr-2" aria-hidden="true" v-if="!carregando"></i>
                        <div class="spinner-border spinner-border-sm mr-2" role="status" v-else>
                          <span class="sr-only">Loading...</span>
                        </div>
                        Importar
                    </button>
                    -->
                </div>
            </nav>

        </div>

        <!-- Formulário de edição -->
        <div class="modal fade" id="edicaoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            Usuário 
                            <template v-if="item">
                                <span class="text-muted">{{ item && item.id_usuario ? '(' + item.st_login + ')' : 'Novo' }}</span>
                                <a href="#" class="card-link" @click.prevent="$util.abrirMedico(item.medico)"
                                    data-toggle="tooltip" data-placement="top" title="Usuário Profissional de Saúde">
                                    <i class="fas fa-user-md ml-2" v-if="item.medico"></i>
                                </a>
                            </template>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <az-empty-state v-if="!item">
                        </az-empty-state>

                        <template v-else>
                            <div class="row">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        sizing="sm"
                                        label="Nome"
                                        required 
                                        :validate="validate"
                                        v-model="item.pessoa.st_nome" />
                                </div>
                                <div class="col col-12 col-md-3" v-if="$store.state.unidade.unidade_operacaos.length > 1">
                                    <az-input
                                        sizing="sm"
                                        label="Unidade"
                                        type="select" 
                                        optionsMode="aql"
                                        optionsData="id_unidade_operacao"
                                        optionsDisplay="st_nome"
                                        :optionsParm="{ where: { fl_ativo: true } }"
                                        service="unidade_operacaos.index"
                                        placeholder="Todas"
                                        v-model="item.id_unidade_operacao" />
                                </div>
                                <div class="col col-12 col-md-3" :class="$store.state.unidade.unidade_operacaos.length > 1 ? 'col-md-3' : 'col-md-6'">
                                    <az-input
                                        sizing="sm"
                                        label="CPF"
                                        type="cpf"
                                        :validate="validate"
                                        v-model="item.pessoa.cadastro.st_cpf" />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col col-12 col-md-3">
                                    <az-input
                                        sizing="sm"
                                        label="Data de Nascimento"
                                        type="date"
                                        :validate="validate"
                                        v-model="item.pessoa.cadastro.dt_nascimento" />
                                </div>
                                <div class="col col-12 col-md-3">
                                    <az-input
                                        sizing="sm"
                                        label="email"
                                        type="email"
                                        :validate="validate"
                                        :required="item.senha_por_email"
                                        v-model="item.pessoa.cadastro.st_email" />
                                </div>
                                <div class="col col-12 col-md-3">
                                    <az-input
                                        sizing="sm"
                                        label="Telefone"
                                        type="fone"
                                        :validate="validate"
                                        v-model="item.pessoa.cadastro.telefones.telefone" />
                                </div>
                                <div class="col col-12 col-md-3">
                                    <az-input
                                        sizing="sm"
                                        label="Celular"
                                        type="fone"
                                        :validate="validate"
                                        v-model="item.pessoa.cadastro.telefones.celular" />
                                </div>
                            </div>

                            <az-sub-title class="mt-1" title="Dados de Acesso" v-if="!item.id_usuario"/>
                            <div class="row" v-if="!item.id_usuario">
                                <div class="col col-12 col-md-3">
                                    <az-input
                                        sizing="sm"
                                        label="Usuário (Login)"
                                        required 
                                        :validate="validate"
                                        :edicao="item.id_usuario ? false : true"
                                        v-model="item.st_login" />
                                </div>
                                <div class="col col-12 col-md-3">
                                    <az-input
                                        sizing="sm"
                                        type="checkbox"
                                        label="Enviar Senha por e-mail"
                                        :validate="validate"
                                        v-show="item.pessoa.cadastro.st_email"
                                        v-model="item.senha_por_email" />
                                </div>
                                <div class="col col-12 col-md-3" v-if="!item.senha_por_email">
                                    <az-input
                                        sizing="sm"
                                        label="Senha"
                                        :required="item.id_usuario ? false : true"
                                        :validate="validate"
                                        v-model="item.senha" />
                                </div>
                                <div class="col col-12 col-md-3" v-if="!item.senha_por_email">
                                    <az-input
                                        sizing="sm"
                                        label="Confirmar Senha"
                                        :required="item.id_usuario ? false : true"
                                        :validate="validate"
                                        v-model="item.confirmar_senha" />
                                </div>
                            </div>

                            <div class="row" v-else-if="(item.id_usuario && $store.state.user.id_usuario == 1)">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        sizing="sm"
                                        label="Usuário (Login)"
                                        required 
                                        :validate="validate"
                                        v-model="item.st_login" />
                                </div>
                            </div>

                            <div class="row" v-if="integracaoLaudite || is_kualiz || integracaoLeoRad">
                                <div class="col col-12 col-md-6" v-if="integracaoLaudite">
                                    <az-input
                                        sizing="sm"
                                        type="email"
                                        label="Email Laudite"
                                        :validate="validate"
                                        v-model="item.st_email_laudite" />
                                </div>

                                <div class="col col-12 col-md-6" v-else-if="integracaoLeoRad">
                                    <az-input
                                        sizing="sm"
                                        label="Token LeoRad"
                                        :validate="validate"
                                        v-model="item.st_email_laudite" />
                                </div>

                                 <div class="col col-12 col-md-6" v-if="is_kualiz">
                                    <az-input
                                        sizing="sm"
                                        label="Id Usuário no Kualiz"
                                        :validate="validate"
                                        v-model="item.st_kualiz_id" />
                                </div>
                            </div>

                            <div class="row" v-if="!setup">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        sizing="sm"
                                        label="PIN (Identificação Coleta)"
                                        :validate="validate"
                                        v-model="item.st_pin" />
                                </div>
                            </div>

                            <div class="row mt-2">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        sizing="sm"
                                        type="checkbox-group"
                                        label="Forçar troca de senha no próximo acesso"
                                        v-model="item.fl_trocar_senha" />
                                </div>

                                <div class="col col-12 col-md-6">
                                    <az-input
                                        sizing="sm"
                                        type="checkbox-group"
                                        label="Bloqueado"
                                        v-model="item.fl_bloqueado" />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        sizing="sm"
                                        type="checkbox-group"
                                        label="Sem acesso a relatórios livres"
                                        v-model="item.fl_block_relatorio_livre" />
                                </div>
                            </div>

                            <div class="row" v-if="!setup && usuario_vs_plano">
                                <div class="col col-12">
                                    <az-input
                                        label="Plano"
                                        sizing="sm"
                                        type="autocomplete"
                                        optionsMode="aql"
                                        optionsName="planos.atendimento"
                                        :optionsParm="{
                                            atendimento: true,
                                            plano_id_unidade_operacao: item.id_unidade_operacao
                                        }"
                                        service="planos.index"
                                        :optionsSync="true"
                                        placeholder="Só acessar paciente do plano..."
                                        optionsData="id_plano"
                                        v-model="item.id_plano" />
                                </div>
                            </div>

                            <div class="row mb-3" v-if="!setup">
                                <div class="col col-12">

                                    <az-sub-title class="mt-1" title="Classificação" />
                                    <multiselect
                                        v-model="item.js_classes"
                                        :options="options_classes"
                                        :multiple="true"
                                        :taggable="true"
                                        @tag="addTag"
                                        placeholder="Selecione uma classificação..."
                                        selectLabel="Pressione [ENTER] para selecionar"
                                        deselectLabel="Pressione [ENTER] para remover"
                                        tagPlaceholder="Pressione [ENTER] para incluir"
                                        selectedLabel="Selecionado">
                                        <template slot="noOptions">
                                            Nenhuma classificação criada.
                                        </template>
                                    </multiselect>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col col-12" :class="!setup ? 'col-md-6' : ''">
                                    <az-sub-title class="mt-1" title="Perfil">
                                        <i class="fa-solid fa-plug"></i>
                                    </az-sub-title>

                                    <div class="row">
                                        <div class="col col-12 col-md-6" v-for="(perfil, ip) in perfils" :key="ip">
                                            <az-input 
                                                sizing="sm"
                                                type="checkbox-group"
                                                :label="perfil.search"
                                                v-model="perfil.selecionado" />
                                        </div>
                                    </div>

                                </div>
                                <div class="col col-12 col-md-6" v-if="!setup">

                                    <az-sub-title class="mt-1" title="Endereço" />
                                    <div class="row">
                                        <div class="col col-12">
                                            <cadastro-endereco sizing="sm" v-model="item.pessoa.cadastro.endereco" />
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <div class="row" v-if="!setup">
                                <div class="col col-12 col-md-6">
                                    <az-sub-title class="mt-1" title="Centros de Custo" />
                                    <az-input v-if="item.centros && item.centros.length"
                                        sizing="sm"
                                        type="checkbox-group"
                                        label="Acesso somente nas unidades selecionadas"
                                        v-model="item.fl_acesso_por_centro_custo" />

                                    <template v-for="(centro, icx) in item.centros">
                                        <div class="form-row" :key="icx" v-if="!centro.excluido">
                                            <div class="col col-12 col-md-6">
                                                <az-input   
                                                    sizing="sm"
                                                    type="label"
                                                    :label="centro.centro.unidade_operacao.search">
                                                    <template v-slot:button-pre>
                                                        <div class="input-group-prepend">
                                                            <button class="btn btn-outline-danger" type="button" id="button-addon1" @click="centro.excluido = true">
                                                                <i class="fa fa-minus" aria-hidden="true"></i>
                                                            </button>
                                                        </div>
                                                    </template>
                                                </az-input>
                                            </div>
                                            <div class="col col-12 col-md-6">
                                                <az-input   
                                                    sizing="sm"
                                                    type="label"
                                                    :label="centro.centro.st_nome" />
                                            </div>
                                        </div>
                                    </template>

                                    <div class="form-row">
                                        <div class="col col-12 col-md-6">
                                            <az-input
                                            sizing="sm"
                                            type="select"
                                            placeholder="Unidade..."
                                            :optionsList="$store.state.unidade.unidade_operacaos"
                                            optionsData="id_unidade_operacao"
                                            v-model="id_nova_unidade" />
                                        </div>
                                        <div class="col col-12 col-md-6"> 
                                            <az-input
                                                icon="fa fa-plus"
                                                sizing="sm"
                                                type="select"
                                                placeholder="Centro de Custo..."
                                                :optionsList="lista_centros"
                                                optionsData="id_centro_custo"
                                                :edicao="id_nova_unidade ? true : false"
                                                v-model="id_novo_centro"
                                                @input="incluir_centro_custo()" />
                                        </div>
                                    </div>

                                    <button type="button" class="btn btn-outline-primary btn-sm mt-3" @click="clonar_de()">Clonar De</button>
                                </div>

                                <!-- Tipos de Movimentação de Estoque -->
                                <div class="col col-12 col-md-6" v-if="1 == 0 && tem_suprimentos(item)">
                                    <az-sub-title class="mt-1" title="Tipos de Movimentação de Estoque" />
                                    
                                    <template v-for="(estoquetipo, icx) in item.estoque_tipos">
                                        <div class="form-row" :key="icx" v-if="!estoquetipo.excluido">
                                            <div class="col col-12">
                                                <az-input   
                                                    sizing="sm"
                                                    type="label"
                                                    :label="estoquetipo.tipo.search">
                                                    <template v-slot:button-pre>
                                                        <div class="input-group-prepend">
                                                            <button class="btn btn-outline-danger" type="button" id="button-addon1" @click="estoquetipo.excluido = true">
                                                                <i class="fa fa-minus" aria-hidden="true"></i>
                                                            </button>
                                                        </div>
                                                    </template>
                                                </az-input>
                                            </div>
                                        </div>
                                    </template>

                                    <div class="form-row">
                                        <div class="col col-12"> 
                                            <az-input
                                                sizing="sm"
                                                icon="fa fa-plus"
                                                placeholder="Tipo de Movimentação de Estoque..."
                                                type="select"
                                                service="estoque_tipo_movimentacaos.index"
                                                optionsMode="aql"
                                                v-model="id_novo_estoque_tipo"
                                                @input="incluir_estoque_tipo()" />
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>

                            <div v-if="!setup && item.campos_customizados" class="row mt-3">
                                <div class="col col-12">
                                    <az-sub-title :title="item.campos_customizados.st_titulo" />
                                    <formulario 
                                        :gutters="true" 
                                        :validate="validate"
                                        v-model="item.campos_customizados.js_campos" 
                                        mode="fixed"
                                        :config="true" />
                                </div>
                            </div>

                            <br><br><br><br><br>

                        </template>

                    </div>
                    <div class="modal-footer" v-if="item">

                        <az-audit-log-button model="usuario" :id="item.id_usuario" v-if="item.id_usuario && !setup" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar ()">{{ item.id_usuario ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Clonar De -->
        <div class="modal fade" id="modalClonarDe" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Clonar De</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <az-input
                            placeholder="Selecione o Usuário de Origem..."
                            type="autocomplete" 
                            optionsMode="aql"
                            service="usuarios.index" 
                            optionsName="filtro-usuarios"
                            :optionsParm="{ ativos: 1 }"
                            required 
                            v-model="usuario_clonar_de" />

                        <div class="mt-3" v-if="usuario_clonar_de">
                            <az-input 
                                sizing="sm"
                                type="checkbox-group"
                                label="Unidade"
                                v-model="clonar.unidade" />

                            <az-input 
                                sizing="sm"
                                type="checkbox-group"
                                label="Classificações"
                                v-model="clonar.classe" />

                            <az-input 
                                sizing="sm"
                                type="checkbox-group"
                                label="Perfil"
                                v-model="clonar.perfil" />

                            <az-input 
                                sizing="sm"
                                type="checkbox-group"
                                label="Unidades / Centros de Custo"
                                v-model="clonar.unid_cc" />
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <az-submit @click="confirm_clonar_de()" :disabled="!usuario_clonar_de">Clonar</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal de Permissões -->
        <div class="modal fade" id="permissaoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="permissoes">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Permissões para {{ usuarioPermissoes ? usuarioPermissoes.search : '' }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row mb-3">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    type="text"
                                    icon="fa fa-search" 
                                    placeholder="Pesquisar..."
                                    v-model="acaoPesquisa" />
                            </div>
                            <div class="col col-12 col-md-6">
                                <az-input 
                                    type="button-group"
                                    :optionsList="[{id: 'S', search:'Selecionados'},{id: 'T', search:'Todos'}]" 
                                    optionsData="id"
                                    v-model="acaoView" />
                            </div>
                        </div>
                        <div v-for="(grupo, ig, igi) in listaPermissoes" :key="ig">
                            <div class="mb-3">
                                <az-sub-title :title="ig" />
                                <ul class="list-group">
                                    <li class="list-group-item d-flex justify-content-between" v-for="(perm, ipm) in grupo" :key="ipm">
                                        <span>{{ perm.st_acao }}
                                            <span class="badge badge-secondary ml-1">#{{ perm.id_acao }}</span>
                                        </span>
                                        <div>
                                            <div class="custom-control custom-switch" v-if="acaoView == 'T'">
                                                <input type="checkbox" class="custom-control-input" 
                                                    :id="'ativo-perm-' + igi + '-' + ipm" 
                                                    v-model="perm.selecionado" 
                                                    @change="togglePermissao(perm)">
                                                <label class="custom-control-label" :for="'ativo-perm-' + igi + '-' + ipm"></label>
                                            </div> 
                                            <div v-else>
                                                <i class="fas fa-check text-success"></i>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Senha -->
        <div class="modal fade" id="senhaModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content" v-if="itemParaSenha">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Alterar Senha de {{ itemParaSenha.pessoa.st_nome }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row mb-3">
                            <div class="col">
                                <az-input 
                                    icon="fas fa-eye"
                                    :buttonIcon="true"
                                    buttonText="fas fa-eye"
                                    @clickButton="itemParaSenha.show_password = !itemParaSenha.show_password"
                                    :type="itemParaSenha.show_password ? 'text' : 'password'"
                                    label="Senha"
                                    v-model="itemParaSenha.senha" />
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col">
                                <az-input 
                                    label="Confirmar Senha"
                                    icon="fas fa-eye"
                                    :buttonIcon="true"
                                    buttonText="fas fa-eye"
                                    @clickButton="itemParaSenha.show_confirm_password = !itemParaSenha.show_confirm_password"
                                    :type="itemParaSenha.show_confirm_password ? 'text' : 'password'"
                                    v-model="itemParaSenha.confirmar_senha" />
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col col-12">
                                <az-input
                                    type="checkbox-group"
                                    label="Forçar troca de senha no próximo acesso."
                                    v-model="itemParaSenha.fl_trocar_senha" />
                            </div>
                        </div>

                        <div v-if="itemParaSenha.pessoa.cadastro.st_email" class="d-flex flex-column mb-3">
                            <div>
                                <i class="far fa-envelope mr-1 text-warning" v-if="itemParaSenha.pessoa.cadastro.st_email"></i>
                                {{ itemParaSenha.pessoa.cadastro.st_email }}
                            </div>
                            <button class="btn btn-outline-primary" 
                                @click="enviarEmailRecuperacaoSenha (itemParaSenha.pessoa.cadastro.st_email)">
                                Enviar e-mail de redefinição de senha
                            </button>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizarSenha()">Alterar Senha</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Acesso Perfil Bloco -->
        <div class="modal fade" id="perfilBlocoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Editar Acessos</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col col-12">
                                <az-input 
                                    icon="fa-solid fa-house-lock" 
                                    placeholder="Selecione..."
                                    type="select"
                                    optionsMode="aql"
                                    service="perfils.index"
                                    :optionsParm="{ uso: true }"
                                    v-model="acesso_perfil"
                                    @input="verificar_acessos()" />
                            </div>
                        </div>

                        <template v-if="acesso_perfil && exibir_acessos">

                            <button type="button" class="btn btn-sm btn-outline-primary my-1" @click="toggle_acesso_todos()">
                                Todos
                            </button>
                        
                            <div class="row" v-for="(usu_item, iux) in lista" :key="iux">
                                <div class="col col-12">
                                    <az-input
                                        type="checkbox-group"
                                        :label="usu_item.search"
                                        v-model="usu_item.perfil_selecionado" />
                                </div>
                            </div>

                        </template>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar_acessos()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Envio de Arquivo -->
        <template v-if="acao_anexar && item && item.arquivos">
            <az-file-upload
                ref="upload"
                @refresh="load()"
                :multiple="true"
                :arquivos="item.arquivos"
                :parms="{ model_type: 'usuario', model_id: item.id_usuario }" />
        </template>

        <medico-lista ref="medicolista" @refresh2="load()" :agenda_compartilhada="true" />

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import CadastroEndereco from '../../shared/CadastroEndereco.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import Multiselect from 'vue-multiselect';
import Importacao from '../shared/Importacao.vue';
import AzFileUpload from '../../util/AzFileUpload.vue';
import MedicoLista from '../../shared/MedicoLista.vue';
import Formulario from '../../modulos/consultorio/Formulario.vue';

export default {
    data () { 
        return { 
            dados: null, 
            em_edicao: false, 
            item: null, 
            itemParaSenha: null, 
            procedimentos: null, 
            validate: false,
            especialidade: null,
            search: "", 
            viewMode: "A",
            perfils: null, 
            filtroPerfil: "", 
            usuarioPermissoes: null, 
            permissoes: null, 
            acaoPesquisa: "",
            acaoView: "S",
            options_classes: [],
            id_nova_unidade: "",
            id_novo_centro: "",
            id_novo_estoque_tipo: "", 
            page: 1, 
            remove_perfil_bloco: false,
            search_perfil: "", 
            acesso_perfil: "",
            exibir_acessos: false, 
            usuario_vs_plano: false, 
            acao_anexar: false, 
            usuario_clonar_de: "", 
            clonar: { 
                perfil: true,
                unid_cc: true, 
                classe: true, 
                unidade: true,
            }, 
            integracaoLaudite: false,
            integracaoLeoRad: false,
            is_kualiz: false
        }
    },

    props: ['medicamentos', 'taxas', 'id_usuario', 'setup'],

    components: { 
        ConfigMainTitle,
        AzInput,
        AzEmptyState,
        AzSubmit,
        AzSubTitle, 
        CadastroEndereco,
        AzAuditLogButton, 
        Multiselect,
        Importacao, 
        AzFileUpload, 
        MedicoLista, 
        Formulario, 
    },

    computed: { 
        lista_centros: function () { 
            
            if ( !this.id_nova_unidade ) 
                return [];

            let und = this.$store.state.unidade.unidade_operacaos.find(item => item.id_unidade_operacao == this.id_nova_unidade);

            return und ? und.centro_custos : [];

        },

        model: function () { 
            return this.medicamentos ? 'medicamento' : 
                ( this.taxas ? 'taxa' : 'material' );
        },
        lista: function () { 
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.dados && this.dados && this.dados.length ? 
                this.dados.filter (item => item.id_usuario != 1 || this.$store.state.user.id_usuario == 1)
                    .filter (item => { 
                        return ( this.viewMode == 'T' || item.fl_ativo ) && 
                            ( !this.search || reg.test(JSON.stringify(item)) );
                    })
                    .sort((a, b) => { 
                        return a.search > b.search ? 1 : -1 ;
                    }) : null;
        },

        lista_perfil: function () { 
            let pesquisar = this.search_perfil.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.dados && this.dados && this.dados.length ? 
                this.dados.filter (item => item.id_usuario != 1 || this.$store.state.user.id_usuario == 1)
                    .filter (item => { 
                        return ( this.viewMode == 'T' || item.fl_ativo ) && 
                            ( !this.search_perfil || reg.test(JSON.stringify(item)) );
                    })
                    .sort((a, b) => { 
                        return a.search > b.search ? 1 : -1 ;
                    }) : [];
        },

        listaPermissoes: function () { 
            if ( !this.permissoes )
                return [];

            let lista = _.sortBy(this.permissoes, function (item) { 
                return item.modulo.search;
            })
            .filter(item => this.acaoView == 'T' || item.selecionado )
            .filter(item => !this.acaoPesquisa || JSON.stringify(item).toLowerCase().indexOf(this.acaoPesquisa.toLowerCase()) >= 0 );
            
            return _.groupBy(lista, function (item) { 
                return item.modulo.search;
            });

        }, 

    },

    methods: { 
        confirm_clonar_de () { 
            this.$util.atualizar(this, { 
                service: 'usuarios',
                func: 'show', 
                dados: { 
                    id: this.usuario_clonar_de.id_usuario, 
                    clone: true, 
                },
                modal: 'modalClonarDe',
                callback: res => { 
                    if ( this.clonar.unidade ) { 
                        this.item.id_unidade_operacao = res.id_unidade_operacao;
                    }

                    if ( this.clonar.classe ) { 
                        this.item.js_classes = ( res.js_classes ? res.js_classes : [] );
                    }

                    if ( this.clonar.unid_cc ) { 
                        this.item.fl_acesso_por_centro_custo = res.fl_acesso_por_centro_custo;

                        res.centros.forEach(item => { 
                            if ( this.item.centros.find(centro => centro.id_centro_custo == item.id_centro_custo && !centro.excluido) ) { 
                                return;
                            }

                            this.item.centros.push({ 
                                id_centro_custo: item.id_centro_custo, 
                                centro: item.centro,
                                excluido: false, 
                            });
                        });
                    }

                    if ( this.clonar.perfil ) {  
                        this.perfils.forEach(perfil => { 
                            perfil.selecionado = ( res.perfil_usuarios.find(item => item.id_perfil == perfil.id_perfil) ? true : false );
                        });
                    }

                    console.log(res);
                }
            });
        },

        clonar_de () { 
            $('#modalClonarDe').modal('show');
        },

        carregar_arquivos(abrir = false) {
            this.$store.commit('loading', true);

            this.$util.loadItem(this, {
                service: 'arquivos',
                func: 'links',
                parms: {
                    id: this.item.id_usuario,
                    type: 'usuario',
                }
            })
            .then(res => {
                this.item.arquivos = res;

                if ( abrir ) {
                    this.$nextTick(() => {
                        this.$refs.upload.abrir();
                    });
                }
            })
            .finally(() => {
                this.$store.commit('loading', false);
            });
        },

        abrir_anexos (usuario) {
            this.item = _.cloneDeep(usuario);

            this.acao_anexar = true;

            if ( this.item.arquivos && this.item.arquivos.length
                && !this.item.arquivos.find(arq => arq.arquivo) ) {

                this.carregar_arquivos(true);
                return;

            }

            this.$nextTick(() => {
                this.$refs.upload.abrir();
            });
        },

        atualizar_acessos () { 
            this.$util.atualizar(this, { 
                service: 'usuarios',
                func: 'atualizar_acessos',
                dados: { 
                    id_perfil: this.acesso_perfil.id_perfil, 
                    lista: this.lista
                },
                modal: 'perfilBlocoModal',
                reload: true
            });
        },

        toggle_acesso_todos() { 
            if ( this.lista.find(item => !item.perfil_selecionado) ) { 
                this.lista.forEach(item => { 
                    item.perfil_selecionado = true;
                });
            } else { 
                this.lista.forEach(item => { 
                    item.perfil_selecionado = false;
                });
            }

            this.$forceUpdate();
        },

        verificar_acessos () { 
            this.exibir_acessos = false;

            if ( !this.acesso_perfil ) { 
                return;
            }

            this.$nextTick(() => { 

                let filtro = { perfil: this.acesso_perfil.id_perfil };
                
                this.$util.loadItem (this, { 
                    service: 'usuarios',
                    func: 'index', 
                    parms: { 
                        ...filtro,  
                        cadastro: true, 
                    },
                    loadTo: dados => { 
                        this.dados = dados;
                    }
                })
                .then(res => { 
                    this.lista.forEach(item => { 
                        item.perfil_selecionado = res.find(usuario => usuario.id_usuario == item.id_usuario) ? true : false;
                    });

                    this.exibir_acessos = true;
                });

            });
        },

        editar_perfil_bloco() {
            this.acesso_perfil = ""; 

            $('#perfilBlocoModal').modal('show');
        },
        
        tem_suprimentos(usuario) { 
            if ( !usuario || !this.perfils )
                return false;

            return this.perfils.find(perfil => perfil.id_perfil == 10 && perfil.selecionado) ? true : false;

        },

        incluir_estoque_tipo() { 
            if ( !this.id_novo_estoque_tipo ) { 
                return;
            }

            let tipo = _.cloneDeep(this.id_novo_estoque_tipo);

            this.item.estoque_tipos.push({ 
                id_estoque_tipo_movimentacao: tipo.id_estoque_tipo_movimentacao, 
                tipo: tipo,
                excluido: false, 
            });

            this.id_novo_estoque_tipo = null;

            this.$nextTick(() => { 
                this.id_novo_estoque_tipo = "";
            });
        },

        incluir_centro_custo() { 
            if ( !this.id_novo_centro ) { 
                return;
            }

            let centro = this.lista_centros.find(item => item.id_centro_custo == this.id_novo_centro);

            if ( !centro ) { 
                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: "Centro de custo não identificado.",
                    life: 3000
                });
            } else { 

                centro = _.cloneDeep(centro);
                centro.unidade_operacao = this.$store.state.unidade.unidade_operacaos.find(item => item.id_unidade_operacao == centro.id_unidade_operacao);

                this.item.centros.push({ 
                    id_centro_custo: this.id_novo_centro, 
                    centro: centro,
                    excluido: false, 
                });

            }

            this.id_novo_centro = null;

            this.$nextTick(() => { 
                this.id_novo_centro = "";
            });
        },

        addTag (newTag) {
            this.options_classes.push(newTag);

            if ( !this.item.js_classes )
                this.item.js_classes = [];

            this.item.js_classes.push(newTag);
        },

        enviarEmailRecuperacaoSenha (email) { 

            this.axios.post('/recuperar', { email: email })
                .then(res => { 

                $('.modal').modal('hide');

                this.$toast.add({
                    severity: res.data.level,
                    summary: "Atenção",
                    detail: res.data.msg,
                    life: 3000
                });

                });

        },
        alterarSenha (item) { 
            this.itemParaSenha = { 
                ...item, 
                senha: "", 
                confirmar_senha: "",
                show_password: false,
                show_confirm_password: false, 
            };

            $('#senhaModal').modal('show');
        },
        atualizarSenha () { 

            this.$util.atualizar(this, { 
                service: 'usuarios',
                func: 'alterar_senha',
                dados: { 
                    id_usuario: this.itemParaSenha.id_usuario,
                    senha: this.itemParaSenha.senha,
                    confirmar_senha: this.itemParaSenha.confirmar_senha,
                    trocar_senha: this.itemParaSenha.fl_trocar_senha,
                },
                toast: true, 
                modal: 'senhaModal'
            });

        },
        incluir () { 
            let item = {
                pessoa: { 
                    st_nome: "", 
                    cadastro: { 
                        st_email: "", 
                        telefones: { 
                            telefone: "",
                            celular: "", 
                        },
                        endereco: {}
                    },
                },
                senha_por_email: false, 
                fl_ativo: true, 
                fl_trocar_senha: false, 
                fl_bloqueado: false, 
                centros: [], 
            };

            this.editar (item);
        },
        load () { 

            let filtro = {};

            if ( this.filtroPerfil ) {
                filtro = { perfil: this.filtroPerfil.id_perfil };
            }

            if ( this.id_usuario ) { 
                filtro.where = { id_usuario: this.id_usuario };
            }

            this.$util.load (this, { 
                service: 'usuarios',
                func: 'index', 
                parms: { 
                    ...filtro,  
                    cadastro: true, 
                },
                configs: ['integracao-laudite', 'integracao-leorad'],
                loadTo: dados => { 
                    this.dados = dados;
                    this.integracaoLaudite = !!this.$store.state.contexto['integracao-laudite'];
                    this.integracaoLeoRad = !!this.$store.state.contexto['integracao-leorad'];

                    if ( this.id_usuario && this.dados.length == 1 ) { 
                        this.editar (this.dados[0]);
                    }
                }
            });
        },
        loadPerfilTo (perfils) { 

            this.perfils = perfils.map (item => { 
                item.selecionado = item.perfil_usuario ? true : false;
                return item;
            });

        },
        loadPermissaoTo (permissoes) { 
            this.permissoes = permissoes.map(item => { 
                if ( item.permissao_usuario ) 
                    item.selecionado = item.permissao_usuario.selecionado; 
                else 
                    item.selecionado = false;

                return item;
            });

            $('#permissaoModal').modal('show');
        },
        editarPermissao (usuario) { 

            this.usuarioPermissoes = usuario;

            this.$util.load (this, { 
                service: 'acaos',
                parms: { 
                    id_usuario: usuario.id_usuario,
                },
                loadTo: this.loadPermissaoTo
            })

        },
        editar (item) { 
            this.id_nova_unidade = "";
            this.id_novo_centro = "";
            this.validate = false;
            this.item = null; 

            this.$store.commit('loading', true);

            $('#edicaoModal').modal('show');

            let query = { q: [
                { 
                    name: "usuarios.show",
                    id: "usuario",
                    parms: { 
                        id: item.id_usuario,
                        cadastro: true,
                        edicao: true, 
                    }
                },
                { 
                    name: "perfils.index",
                    id: "perfils",
                    parms: { 
                        id_usuario: item.id_usuario ? item.id_usuario : -1, 
                        where: { 
                            fl_permitir_uso: true, 
                        },
                    }
                },
                { 
                    name: "configuracoes.index",
                    id: "configplano",
                    parms: { 
                        where: { 
                            st_slug: 'usuario-vs-plano', 
                            st_valor: '1'
                        },
                    }
                },
            ]};

            this.axios.post('/aql?a=usuarios.show', query)
                .then(res => { 
                    if ( item.id_usuario && res.data.usuario.status == 200 ) { 
                        this.item = res.data.usuario.data;

                        if ( this.item.id_unidade_operacao === null ) { 
                            this.item.id_unidade_operacao = "";
                        }
                        
                        if ( !this.item.pessoa.cadastro ) { 
                            this.item.pessoa.cadastro = {};
                        }

                        if ( !this.item.pessoa.cadastro.endereco ) { 
                            this.item.pessoa.cadastro.endereco = {};
                        }

                        if ( !this.item.pessoa.cadastro.telefones ) { 
                            this.item.pessoa.cadastro.telefones = {};
                        }
                    }

                    if ( res.data.perfils.status == 200 ) { 
                        this.loadPerfilTo(res.data.perfils.data);
                    }

                    if ( res.data.configplano.status == 200 ) { 
                        if ( res.data.configplano.data.length ) { 
                            this.usuario_vs_plano = true;
                        }
                    }
                })
                .finally (() => { 
                    this.$store.commit('loading', false);
                });

            if ( !item.id_usuario ) { 
                this.item = _.cloneDeep (item);
            }

            /*
            this.$util.load(this, { 
                service: 'perfils', 
                parms: { 
                    id_usuario: item.id_usuario ? item.id_usuario : -1, 
                    where: { 
                        fl_permitir_uso: true, 
                    },
                }, 
                loadTo: this.loadPerfilTo, 
            });
            */
        },
        atualizar () { 
            this.$util.atualizar (this, { 
                service: 'usuarios',
                dados: { 
                    ...this.item,
                    perfils: this.perfils 
                },
                reload: true,
                modal: 'edicaoModal',
            });
        },
        fechar () { 
            this.em_edicao = false;

            this.em_edicao = false;

            if ( !this.setup ) { 
                this.$store.commit('setBreadcrumb', this.breadcrumb);
            }
        },
        toggle (item) { 

            this.$util.toggle (this, { 
                service: 'usuarios', 
                dados: { ...item }, 
            });

        },
        togglePermissao (item) { 
            this.$util.atualizar(this, { 
                service: 'usuarios',
                func: 'permissao',
                dados: { 
                    id_usuario: this.usuarioPermissoes.id_usuario,
                    id_acao: item.id_acao,
                    selecionado: item.selecionado, 
                },
            });
        },
        format (n) { 
            let formatter = new Intl.NumberFormat('pt-Br', {
                style: 'currency',
                currency: 'BRL',
                currencyDisplay: 'code',
            });

            return formatter.format(n).substr(4);
        },
    },

    mounted () { 
        this.load ();

        if ( !this.setup ) { 

            this.breadcrumb = [
                    { name: "Configurações", path: "/cadastros"},
                    { name: "Usuários", method: this.fechar },
                ];

            this.$store.commit('setBreadcrumb', this.breadcrumb);

            this.$refs['pesquisa'].$refs.input.focus ();

        }

        this.$util.loadItem(this, { 
            service: 'usuarios',
            func: 'tags',
        })
        .then(res => { 
            this.options_classes = res;
        });

        this.$util.loadItem(this, { 
            service: 'configuracoes',
            func: 'servico_whatsapp',
        })
        .then(res => { 
            this.is_kualiz = (res && res.servico == 'QualizapHelper')
        });

    },

    updated () { 
        $('[data-toggle="tooltip"]').tooltip();
    }


}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>